import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { PageHeader } from '../../../../utils/models/page-header';
import { Region } from '../../models/region';
import { RegionService } from '../../services/region.service';
import { CoreSaveService, UtilsService, MessageService, ICommonMessage, FieldType, ConfigService } from '@gbs-platform-client/fwk-core'
import { NotificationsService } from '@gbs-platform-client/building-blocks';
import { APIResponse } from 'src/app/utils/models/response';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';
import { Employee } from '../../models/employee';
import { EmployeeService } from '../../services/employee.service';
import { Zone } from '../../models/zone';
import { ZoneService } from '../../services/zone.service';
import { State } from '../../models/state';
import { StateService } from '../../services/state.service';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent implements OnInit {
  @ViewChild('excelexport', { static: false }) excelexport!: ExcelExportComponent;
  @ViewChild('view') view!: TemplateRef<any>;
  private unsubscribe$: Subject<void> = new Subject<void>();
  headerRegion: PageHeader;
  entity: Region = new Region();
  selectedRegion: Region = new Region();
  editingEntity: Region = new Region();
  Zone: Zone = new Zone();
  regions: any;
  regionColumns: any[]=[];
  listView: boolean = true;
  formCaption: string = '';
  company: Array<Company> = [];
  selectedCompany: any;
  emailcheck: boolean = true;
  defaultPageSize: number;
  pageSkip: number = 0;
  pageSizes: any = [];
  defaultRowsCount: number;
  saveDisabled: boolean = false;
  employees: Array<Employee> = [];
  selectedEmployee: any;
  zone: Array<Zone> = [];
  selectedZone: any;
  state: Array<State> = [];
  selectedState: any;
  codeCheck: boolean = true;
  codealCheck: boolean = true;
  opened: boolean = false;
  details: any;
  constructor(
    private _regionService: RegionService,
    private _companyService: CompanyService,
    private _zoneService: ZoneService,
    private _stateService: StateService,
    private _coreSaveService: CoreSaveService,
    private configService: ConfigService,
    private _employeeService: EmployeeService,
    private messageService: MessageService,
    private notification: NotificationsService,
  ) {
    this.headerRegion = this.initPageHeader();
    this.defaultPageSize = Number(this.configService.getConfigValue('defaultPageSize'));
    this.pageSizes = this.configService.getConfigValue('pageSizes');
    this.defaultRowsCount = Number(this.configService.getConfigValue('defaultRowsCount'));
    this.regions = [];
    this.getAllRegion();
  }
    ngAfterViewInit(): void {
    this.regionColumns = [
      { field: "SlNo", title: 'SL No.', filter: false, sortable: true, width: 70 },
      { field: "RegionName", title: 'Region', filter: true, sortable: true, width: 100 },
      { field: "RegionCode", title: 'Code', filter: true, sortable: true, width: 100 },
      { field: "EmployeeName", title: 'Region Head', filter: true, sortable: true, width: 100 },
      { field: "RegionMail", title: 'Email Id', filter: true, sortable: true, width: 100 },
      { field: "RegionPhone", title: 'Phone', filter: true, sortable: true, width: 100 },
      // { field: "CompanyName", title: 'Company', filter: true, sortable: true },
      //{ field: "ZoneName", title: 'Zone', filter: true, sortable: true },
      { field: "StateName", title: 'State', filter: true, sortable: true, width: 100 },
      { field: "Active", title: 'Active', filter: false, sortable: true , width: 100},
      { field: "", title: '', filter: true, sortable: true, width: 60, template: this.view }
    ];
  }
   
  onPaginationChange(event: any) {
    if (this.defaultPageSize != event.take) {
      this.defaultPageSize = event.take;
    }
    this.pageSkip = event.skip;
    this._regionService.getAllRegions('', this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 0, 0).subscribe((entities: Array<Region>) => {
      this.regions = {
        data: entities,
        total: entities[0] ? entities[0].TotalCount : 0
      }
    });
  }
  getAllCompany(filter: string) {
    this._companyService.getAllCompany(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Company>) => {
      this.company = data;
    })
  }
  Statechanged(state: any) {
    this.zone = [];
    this.entity.Zone_Id = '';
    this.selectedZone = { Zone_Id: '', Zone_Name: ''};
    if (state) {
      // this.getAllState(this.entity.State_Id);
      this.getAllZone('');
    }
  }
  getAllZone(filter: string) {
    this._zoneService.getAllStatesbyzone(this.entity.State_Id).subscribe((data: Array<Zone>) => {
      this.zone = data;
    })
    this.selectedZone = { Zone_Id: this.zone[0].Zone_Id, Zone_Name: this.zone[0].Zone_Id };

  }
  goToBackTab(): void {
    this.listView=true;
}
  getAllState(filter: string) {
    this._stateService.getAllStates(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<State>) => {
      this.state = data;
    })
  }

  getAllEmployees(filter: string) {
    this._employeeService.getAll_Employees(filter, this.defaultRowsCount, 1, 0, 1).subscribe((data: Array<Employee>) => {
      this.employees = data;
    })
  }
  onFilterChange(event: any): void {
    if (((event && event.filter && event.filter.filters[0] && event.filter.filters[0].filters[0]) != null)) {
      var filter = (event.filter.filters[0].filters[0].field + '|' + event.filter.filters[0].filters[0].value + ';');
      //1 for gridfilter type
      this._regionService.getAllRegions(filter, this.defaultPageSize, ((this.pageSkip / this.defaultPageSize) + 1), 1, 0).subscribe((regions: Array<Region>) => {
        this.regions = {
          data: regions,
          total: regions[0] ? regions[0].TotalCount : 0
        }
      });
    }
  }
  getAllRegion() {
    this._regionService.getAllRegions('', Number(this.defaultPageSize), 1, 0, 0).subscribe((regions: Array<Region>) => {
      this.regions = {
        data: regions,
        total: regions[0] ? regions[0].TotalCount : 0
      }
    })
  };


  onPaste(event: any) {
    let Data = event.Data;
    let regexp = new RegExp('[^-_().;:,!a-zA-Z0-9/ ]');
    let pastedText = Data.getData('text');
    let test = regexp.test(pastedText);
    let trimmedText = pastedText.replace(/[^a-zA-Z0-9-()._ ]/g, '');
    (<HTMLInputElement>document.getElementById('bindingId')).value = trimmedText;
    if (test) {
      event.preventDefault();
    }
  }
  ngOnInit(): void {
    this.messageService.activeCommonMessage.pipe(takeUntil(this.unsubscribe$)).subscribe((message: ICommonMessage | null) => {
      if (message?.eventName === 'delete_read_confirmation') {
        if (message?.param.action === "FA") {
          this._regionService.deleteRegion(this.selectedRegion.Region_Id).subscribe((entity: any) => {
            this.notification.showSuccess('Deleted Successfully');
            this.clearRegion();
            this.getAllRegion();
          },
          )
        }
      }
    });
  }

  initPageHeader(): PageHeader {
    let headerRegion = new PageHeader();
    headerRegion.PageCaption = "Region";
    headerRegion.IconClass = "bi bi-shield-shaded";
    return headerRegion;
  }

  deleteRegion(event: any) {
    if (event.seletedRows[0]) {
      this.selectedRegion.Region_Id = event.seletedRows[0];
      var message: ICommonMessage = {
        eventName: "showDialog",
        param: {
          content: "Do you want to delete this entry ?",
          caption: "Region",
          returnKey: "delete_read_confirmation"
        }
      };
      this.messageService.sendCommonMessage(message);
    }
  }

  addRegion(event: any) {
    this.listView = false;
    this.clearRegion();
    this.getAllCompany('');
    this.getAllEmployees('');
    //this.getAllZone('');
    this.getAllState('');
    this.formCaption = "Add Region";
  }

  editRegion(event: any): void {
    if (event.seletedRows[0]) {
      this._regionService.viewRegion(event.seletedRows[0]).subscribe((regions: Array<Region>) => {
        let editEnity = regions[0] ? regions[0] : new Region();
        if (editEnity) {
          this.editingEntity = editEnity;
          this.selectedCompany = { Company_Id: editEnity.Company_Id, CompanyName: editEnity.CompanyName };
          this.selectedEmployee = { Emp_Ref_Id: editEnity.Emp_Ref_Id, EmployeeName: editEnity.EmployeeName };
          this.selectedZone = { Zone_Id: editEnity.Zone_Id, Zone_Name: editEnity.ZoneName };
          this.selectedState = { State_Id: editEnity.State_Id, State_Name: editEnity.StateName };

          this.entity = { ...this.editingEntity };
          this.listView = false;
          this.formCaption = "Edit Region";
          this.getAllCompany('');
          this.getAllEmployees('');
          // this.getAllZone('');
          this.getAllState('');
          this.entity.EntityMetaData = [
            { FieldName: 'RegionName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            { FieldName: 'Phone', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Phone is required' },
            { FieldName: 'EmailId', FieldType: FieldType.String, IsMandatory: false, ValidationMessage: 'Email is required' },
            //{ FieldName: 'Emp_Ref_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Region Head is required' },    
            //{ FieldName: 'Company_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Company is required' },
            //{ FieldName: 'Zone_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Zone is required' },     
            //{ FieldName: 'State_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'State is required' },     
          ];
        }
      });
    }
  }

  checkContactNo(event: any): void {
    const re = /^(0*[1-9]+0*)+$/;
    this.codeCheck = re.test(String(this.entity.Code).toString());
    if (this.codeCheck == false) {
      this.notification.showWarning("Invalid code ");
      return;
    }

  }

  save(event: any): void {
    if(parseInt(this.entity.Code)==0)
    {
      this.notification.showWarning('Zero not allowed');
      return
    }
    this.saveDisabled = true;
    let validations = this._coreSaveService.saveValidation(this.entity);
    if (validations.length === 0) {
      this._regionService.checkDuplication(this.entity.Region_Id,this.entity.Code).subscribe((res) => {
        if (res.Success === false) {
          this.notification.showWarning('Region Code already exists');
          this.saveDisabled = false;
        }
        else {
          if (this.entity.Phone.length != 0 && this.entity.Phone.length != 10) {
            this.notification.showWarning("Invalid Phone No.");
            this.saveDisabled = false;
          }
          // const re = /^(0*[1-9]+0*)+$/;
          // const real=/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
          // this.codeCheck = re.test(String(this.entity.Code).toString());
          // this.codealCheck = real.test(String(this.entity.Code).toString());
          // if (this.codealCheck == false&&this.codeCheck==false ) {

          //   this.notification.showWarning("Invalid code ");
          //   this.saveDisabled = false;

          // }

          else {
            if (this.entity.EmailId != "") {
              // const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;commented on 04-06-2024 by jessil for #I238
              const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+")){2,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              this.emailcheck = re.test(String(this.entity.EmailId).toLowerCase());
              if (this.emailcheck === false) {
                this.notification.showWarning("Email not valid");
                this.saveDisabled = false;
                return;
              }}
              
                this._regionService.checkEmail(this.entity.EmailId, this.entity.Region_Id).subscribe((response) => {
                  if (response.Success == false) {
                    this.notification.showWarning("Email already exists");
                    this.saveDisabled = false;
                    return;
                  }
                  else {
                    this._regionService.saveRegion(this.entity).subscribe(() => {
                      if (this.entity.Region_Id == '00000000-0000-0000-0000-000000000000') {
                        this.notification.showSuccess('Saved Successfully');
                      }
                      else {
                        this.notification.showSuccess('Updated Successfully');
                      }
                      this.listView = true;
                      this.clearRegion();
                      this.getAllRegion();
                    });
                  }
                });
              }
            }
      });
    }
    else {
      this.saveDisabled = false;
    }

  }


  AlphabetsOnly(event: any): boolean {
    var inp = String.fromCharCode(event.keyCode);
    if (/^[a-zA-Z\s]*$/.test(inp)) {
      return true;
    } else {
      return false;
    }

  }
  RestrictZero(event: any) {
    if (event.target.value.length === 0 && event.key === "0") {
      this.notification.showWarning("Invalid Code.");
      event.target.value = "";
      this.entity.Code == "";
    }

  }
  gotoBack(): void {
    this.listView = true;
    this.getAllRegion();
  }

  refreshRegions(event: any): void {
    this.regions = [];
    this.getAllRegion();
  }

  clearRegion(): void {
    this.selectedCompany = {};
    this.selectedEmployee = {};
    this.selectedZone = {};
    this.selectedState = {};
    this.entity = new Region();
    this.saveDisabled = false;
  }

  onExcelExport() {
    this.excelexport.save()
  }

  revertChanges(): void {
    this.entity = { ...this.editingEntity };
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  public close() {
    this.opened = false;
  }
  public open(dataItem: any): void {
 this.entity.Region_Id=dataItem.Region_Id;
 this.details =[];
 this._regionService.viewRegion(this.entity.Region_Id).subscribe((regions: Array<Region>) => {
  this.opened = true;
  this.details = regions[0];
  })}


}
